import Seo from '@/components/seo/seo';
import { getLayoutWithFooter } from '@/components/layouts/layout-with-footer';
import DeliveryPartnerForm from '@/components/parceiros-de-entrega/delivery-partner-form';
import { getStaticProps } from '@/framework/parceiros-de-entrega.ssr';
export { getStaticProps };

const HIGHLIGHTS = [
  {
    title: 'Você escolhe quando rodar',
    description:
      'Informe os dias e períodos que combinam com a sua rotina. Sem escala fixa.',
  },
  {
    title: 'Rotas na sua região',
    description:
      'Selecione as regiões da Grande São Paulo em que prefere fazer entregas.',
  },
  {
    title: 'MEI ou RPA',
    description:
      'Atenda como microempreendedor individual ou como autônomo, do seu jeito.',
  },
];

export default function ParceirosDeEntregaPage() {
  return (
    <>
      <Seo
        title="Parceiros de entrega"
        description="Cadastre-se para ser parceiro de entrega da Qualidoc e participar da logística da farmácia online."
        url="parceiros-de-entrega"
      />

      <section className="bg-gray-100 px-4 py-12 sm:py-16">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-accent">
            Trabalhe com a Qualidoc
          </p>
          <h1 className="mb-4 text-3xl font-bold text-heading sm:text-4xl">
            Seja um parceiro de entrega
          </h1>
          <p className="text-base text-body sm:text-lg">
            Leve saúde até a casa das pessoas. Preencha o cadastro em três
            etapas rápidas e nosso time entra em contato com os próximos passos.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-4 sm:grid-cols-3">
          {HIGHLIGHTS.map((highlight) => (
            <li
              key={highlight.title}
              className="rounded-2xl border border-border-base bg-light p-5"
            >
              <h2 className="mb-1 text-sm font-semibold text-heading">
                {highlight.title}
              </h2>
              <p className="text-sm text-body">{highlight.description}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="px-4 py-12 sm:py-16">
        <DeliveryPartnerForm />
      </section>
    </>
  );
}

ParceirosDeEntregaPage.getLayout = getLayoutWithFooter;
